import './App.css'
import Group from './pages/group.jsx';
import AddToDo from './pages/addToDo';
import OnionHater from './pages/onionHater';
import Destiny from './pages/Destiny';
import Destiny_useState from './pages/Destiny_useState';
import OnionHater_useSate from './pages/onionHater_useState';



function App() {

  return (
  <div>
    <div>
      {/* <Group/> */}
      <AddToDo/>
      {/* <OnionHater/> */}
      {/* <Destiny/> */}
      {/* <Destiny_useState/> */}
      {/* <OnionHater_useSate/> */}
      {/* <Container/> */}
    </div>
  </div>
  );
}

export default App;
